import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4131",
              width: 33,
              height: 32,
              x: 8,
              y: 9,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M39.9 9.38a.75.75 0 0 0-1.02-.28c-12.61 7.21-16.86 21.73-18.14 28.04-1.45-3.46-4.81-8.9-11.83-10.37-.4-.08-.8.18-.89.58-.08.41.18.8.58.89 9.5 1.98 11.63 12.06 11.65 12.16.07.35.38.6.73.6h.04c.37-.02.67-.3.71-.67.02-.21 2.27-20.99 17.9-29.92.35-.22.48-.67.27-1.03"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4131)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyYesIcon";
export {
  i as AgencyYesIcon,
  i as default
};
//# sourceMappingURL=index.js.map
